export default __webpack_public_path__ + "static/filters-9537447fd13f0a845acfe5d780901d47.png";